/* eslint-disable eqeqeq */
import { Component, Input, OnInit, Output, EventEmitter, ViewChild, OnChanges, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { formatArrivalDate, generateArray } from '../../../../../../utils/Functions';
import { ItineraryService } from '../../../../../../shared/itinerary.service';
import { RestService } from '../../../../../../shared/rest.service';
import { BsModalRef, BsModalService, ModalDirective, ModalOptions } from 'ngx-bootstrap/modal';
import { ConfirmationModalComponent } from '../../../../../../shared/modals/confirmation-modal/confirmation-modal.component';
import { MaterialModalConfirmComponent } from '../../../../../../shared/material-modal-confirm/material-modal-confirm.component';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { UserService } from '../../../../../../pages/com.usblick.common/auth/user.service';
import { ModalsComponent } from '../../../../../../shared/modals/modals.component';
import { MaterialModalAlertComponent } from 'app/shared/material-modal-alert/material-modal-alert.component';
import { ModalLoadingComponent } from 'app/shared/modal-loading/modal-loading.component';
import { ResultsSearchService } from 'app/home/results-search.service';
import { Router } from '@angular/router';
import { DynamicFontSizePipe } from 'app/shared/dynamic-font-size.pipe';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { CurrencyConverterPurePipe } from 'app/shared/currency-converter-pure.pipe';
import { NotificationService } from 'app/shared/notifications/notification.service';

@Component({
  selector: 'usb-item-hotel',
  templateUrl: './item-hotel.component.html',
  styleUrls: ['./item-hotel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    ResultsSearchService, DynamicFontSizePipe,CurrencyConverterPurePipe
  ]
})
export class ItemHotelComponent implements OnInit, OnChanges {
  @Input() dato: any;
  @Input() rooms: any[] = null; // Habitaciones adicionales del mismo hotel (parsed via getItem)
  @Input() isStayRepeat = false; // Indica si es un hotel repetido en día intermedio
  @Input() currencies: any[];
  @Input() isCheckIn: boolean;
  @Output() itemDelete = new EventEmitter<any>();
  @Output() itemToPartial = new EventEmitter<number>();
  @Output() delete = new EventEmitter<string>();
  @Output() cancel = new EventEmitter<string>();
  @Input() partialReserve: boolean;
  @Input() clientSetting: any;
  @Input() permissions: any[] = [];
  @Input() currencyAgency: any;
  @Input() item: any;
  blickoins: any;
  @ViewChild('modalRooms') modalRooms: ModalDirective;

  currencyItinerary: string;
  bsModalRef?: BsModalRef;
  rate = 0;
  starArray: number[] = [1, 2, 3, 4, 5];
  currentDate = new Date();

  starValidate = false;
  fontSizeAdjustments = { 6: -1, 8: -2, 10: -5 };
  public styleSidebar: any;

  public formatDate = formatArrivalDate;
  public generateStars = generateArray;

  // Propiedades cacheadas para evitar re-render constante
  displayRooms: any[] = [];
  roomCount = 1;
  totalPrice = 0;
  roomStatuses: { status: string; status_id: number }[] = [];
  uniqueRoomStatuses: { status: string; status_id: number }[] = [];

  // Toggle rooms list
  roomsExpanded = false;

  toggleRooms(): void {
    this.roomsExpanded = !this.roomsExpanded;
    this.cdr.markForCheck();
  }

  trackByRoom(index: number, room: any): any {
    return room.id || room.payloadUpdate?.products?.[0]?.id || index;
  }

  constructor(
    private itineraryService: ItineraryService,
    private restService: RestService,
    private dialog: MatDialog,
    public userService: UserService,
    private modalService: BsModalService,
    private resultsSearch: ResultsSearchService,
    private router: Router,
    private notificationService: NotificationService,
    private ngxSpinner: NgxSpinnerService,
    public _restService: RestService,
    private currencyPipe: CurrencyConverterPurePipe,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
   this.currencyItinerary = this.dato?.currency;
   this.getStarsHotels();
   this.styleSidebar = JSON.parse(this.clientSetting.clients_setting_app_booking?.bookingFlow_sidebar);
   this.recalcCachedValues();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Recalcular solo cuando cambian los inputs relevantes
    if (changes['dato'] || changes['rooms']) {
      this.recalcCachedValues();
    }
    this.cdr.markForCheck();
  }

  private recalcCachedValues(): void {
    // Protección: dato puede ser null durante el primer ciclo de change detection
    if (!this.dato) {
      this.displayRooms = [];
      this.roomCount = 0;
      this.totalPrice = 0;
      this.roomStatuses = [];
      return;
    }

    // displayRooms
    if (!this.rooms || this.rooms.length === 0) {
      this.displayRooms = [this.dato];
    } else {
      this.displayRooms = this.rooms;
    }

    // roomCount
    this.roomCount = this.displayRooms.length;

    // totalPrice
    this.totalPrice = this.displayRooms.reduce((sum, room) => sum + this.getPrice(room), 0);

    // roomStatuses: obtener todos los status de cada room (puede haber repetidos)
    const seen = new Set<number>();
    this.roomStatuses = this.displayRooms
      .filter(room => room.status_id && room.status)
      .map(room => ({ status: room.status, status_id: room.status_id }));

    // uniqueRoomStatuses: deduplicado por status_id usando Set
    this.uniqueRoomStatuses = this.roomStatuses.filter(item => {
      if (seen.has(item.status_id)) {
return false;
}
      seen.add(item.status_id);
      return true;
    });

    // OnPush: marcar para check después de actualizar valores cacheados
    this.cdr.markForCheck();
  }


  edit(item: any){

    // modo quoute
    if (item.status_id == 1) {
      const message = '¿Deseas eliminar este item y buscar un nuevo hotel en ' +
      item.location +
      ' del ' +
      this.returnDate(item.arrivalDate) +
      ' hasta ' +
      this.returnDate(item.departureDate) +
      ' para ' +
      item.paxAdults +
      ' adultos?';

      const initialState: ModalOptions = {
        initialState: {
          title: 'Eliminar',
          message: message.replace(/\?/g, '?<br />'),
          icon: 'assets/icons/itinerary-detail/04-01.svg'
        }
      };

      this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
      const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe(async (result: boolean) => {
        if(result) {
          await this.makePayload(item);
          await this.itineraryService.remove(item !== undefined ? item : item);
        } else {

        }
        confirmSubscription.unsubscribe();
      });
    }
  }

  makePayload(item: any) {
    const _payload = [];

    const  payload = item.payloadUpdate.products[0];
    const form = item.form;
    _payload[0] = payload;

    localStorage.setItem('form', JSON.stringify(form));
    localStorage.setItem('payload', JSON.stringify(_payload));

    this.openModalLoading(JSON.parse(localStorage.getItem('payload')));

    this.restService.doPost('app', 'search', payload).subscribe(
            (response: any) => {
              if (response !== null && response.results !== null) {
                const payloadArray = [payload];
                this.resultsSearch._setPayload(payloadArray);
                localStorage.setItem('form', JSON.stringify(form));
                localStorage.setItem('payload', JSON.stringify(payloadArray));
                this.resultsSearch._setOrigin(item.categoryName);

                this._setSearchIdInResults(response);
                if (response.results.length > 0) {
                  this._handleResponse(response, item.categoryName, item);
                  this.dialog.closeAll();
                  this.itineraryService.notifyModalClosed(true);
                  setTimeout(() => {
                    this.router.navigate(['/results']);
                  }, 200);
                } else {
                  this.dialog.closeAll();
                  const dialogRef = this.dialog.open(MaterialModalAlertComponent, {
                    height: 'auto',
                    width: '350px',
                    data: 'No se encontraron Resultados',
                    disableClose: true,
                  });
                }
              }
            },
            (error) => {
              this.dialog.closeAll();
              const message = 'Ocurrió un error al intentar encontrar productos';
              const dialogRef = this.dialog.open(MaterialModalConfirmComponent, {
                width: '450px',
                data: {message},
                disableClose: true,
              });
              dialogRef.afterClosed().subscribe((result) => {
                if (result) {
                  this.makePayload(item);
                } else {
                  this.dialog.closeAll();
                }
              });
            }
          );
  }

  _setSearchIdInResults(response: any) {
    response.results.forEach((obj) => {
      obj.searchId = response.searchId;
    });
  }

  _handleResponse(response: any, categoryName: string, payload: any) {
    if (response && response.results != null) {
      try {
        let _resultsQuery: any;
        _resultsQuery = response.results;
        _resultsQuery.categoryName = categoryName;
        _resultsQuery.arrivalDate = payload.arrivalDate;
        _resultsQuery.destination = payload.destination.iata_code;
        if (!response.results.length) {
          _resultsQuery.noResultMessage = 'No results found for the search';
        }
        const arrayResults = [_resultsQuery];

        this.resultsSearch._setResponse(arrayResults);
      } catch (e) {
        console.log('error', e);
      }
    }
  }

    /// modal loading
    openModalLoading(data: any) {
      const dialogRef = this.dialog.open(ModalLoadingComponent, {
        width: '650px',
        id: 'loadModal',
        data,
        disableClose: true,
      });

      /* dialogRef.afterClosed().subscribe(result => {
        });*/
    }

    returnDate(date: any) {
      const dateSplit = date.split('-');
      return (
        '' +
        dateSplit[2] +
        '-' +
        moment()
          .month(parseInt(dateSplit[1]) - 1)
          .format('MMM')
      );
    }



  getProduct(){

    if (this.dato.payloadUpdate) {
      this.restService.doPost('app', 'search/products', this.dato.payloadUpdate).subscribe(
        (response: any) => {
          if(this.isCheckIn && !this.dato.nr){
            this.updateNRProduct();
          }

          if (response && response.status && response.results) {
            if (response.results[0] !== undefined) {
              this.dato.product = response.results[0];
            } else {
              this.dato.product = response.results;
            }
          }
        }, error => {
          console.log(error.message);
        }
      );
    }
  }

  removeItem(item: any) {
    // Si hay múltiples rooms agrupadas, eliminar TODAS
    const itemsToRemove = this.roomCount > 1 ? this.displayRooms : [item];

    let message = '';

    if ((item.status_id == 1) ||  (item.status_id == 5)) {
      message = itemsToRemove.length > 1
        ? `¿Está seguro de eliminar las ${itemsToRemove.length} habitaciones?`
        : 'Esta seguro de Eliminar el Producto?';
    }
    if (item.status_id == 2) {
      if(this.verifiedReservationId(item)) {
        message = 'Hay más productos con el mismo localizador ¿Está seguro de cancelar los productos?';
      } else {
        message = '¿Esta seguro de cancelar el producto?';
      }
    }

    const initialState: ModalOptions = {
      initialState: {
        title: item.status_id === 2 ? 'Cancelar' : 'Eliminar',
        message: message.replace(/\?/g, '?<br />'),
        icon: 'assets/icons/itinerary-detail/04-01.svg'
      }
    };

    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
    const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
      if(result) {
        if((item.status_id == 1) ||  (item.status_id == 5) ) {
          // Eliminar todas las rooms secuencialmente
          itemsToRemove.forEach(roomItem => {
            const paxesQty = {
              destination: roomItem.destination?.iata_code || roomItem?.form?.destination?.city_iata_code,
              adults: Number(roomItem.paxAdults || roomItem.payloadUpdate?.products?.[0]?.others?.hotels?.roomConfiguration?.[0]?.adults || 0),
              children: Number(roomItem.paxChildren || roomItem.payloadUpdate?.products?.[0]?.others?.hotels?.roomConfiguration?.[0]?.children?.length || 0)
            };
            this.userService.itineraryActive[0]['destination'].forEach((destination: any) => {
                if(destination.iata_code === paxesQty.destination) {
                  destination.destination_info.adults -= paxesQty.adults;
                  destination.destination_info.childs -= paxesQty.children;
                }
            });
            this.deleteItem(roomItem);
          });
        }
        if (item.status_id == 2) {
          // Cancelar todas las rooms
          itemsToRemove.forEach(roomItem => {
            this.cancelReservation(roomItem);
          });
        }
      } else {

      }
      confirmSubscription.unsubscribe();
    });
  }

  /**
   * Elimina una habitación individual del listado desplegable.
   */
  removeRoom(room: any) {
    const initialState: ModalOptions = {
      initialState: {
        title: 'Eliminar',
        message: '¿Está seguro de eliminar esta habitación?',
        icon: 'assets/icons/itinerary-detail/04-01.svg'
      }
    };

    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
    const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
      if (result) {
        this.deleteItem(room);
      }
      confirmSubscription.unsubscribe();
    });
  }

  /**
   * Cancela una habitación individual (status_id === 2).
   */
  cancelRoom(room: any) {
    const message = this.verifiedReservationId(room)
      ? 'Hay más productos con el mismo localizador ¿Está seguro de cancelar los productos?'
      : '¿Esta seguro de cancelar esta habitación?';

    const initialState: ModalOptions = {
      initialState: {
        title: 'Cancelar',
        message: message.replace(/\?/g, '?<br />'),
        icon: 'assets/icons/itinerary-detail/04-01.svg'
      }
    };

    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
    const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
      if (result) {
        this.cancelReservation(room);
      }
      confirmSubscription.unsubscribe();
    });
  }

  /**
   * Edita una habitación individual (lanza búsqueda con payload de esa room).
   */
  editRoom(room: any) {
    this.edit(room);
  }

    verifiedReservationId(item): boolean {
    let matchReservationId: any[] = [];
    switch(item?.category_id) {
  case 1:
          matchReservationId = this.userService.itineraryActive[0].items.filter(c => c.resultReserve?.providerReservationId === item?.resultReserve?.providerReservationId);
    break;
  case 2:
          matchReservationId = this.userService.itineraryActive[0].items.filter(c => c.resultReserve?.providerReservationId === item?.resultReserve?.additionalInfo?.idReservation);
    break;
  case 6:
          matchReservationId = this.userService.itineraryActive[0].items.filter(c => c.resultReserve?.providerReservationId === item?.resultReserve?.additionalInfo?.idReservation);
    break;
  case 8:
          matchReservationId = this.userService.itineraryActive[0].items.filter(c => c.resultReserve?.providerReservationId === item?.resultReserve?.providerReservationId);
    break;

}

    return matchReservationId && matchReservationId.length > 1;
  }



  deleteItem(item: any) {
    this.itineraryService.remove(item !== undefined ? item : item);
    setTimeout(() => {
      this.delete.emit(item.id);
      this.userService.updateProductsPrices(item.itinerary_id);
    }, 1000);
  }

  cancelReservation(item: any) {


const productsIdArr = item.map(c => c.id);


this.ngxSpinner.show();
const cancelData: any = {};
switch(item?.category_id) {
  case 1:

    cancelData['providerId'] = item?.providerId;
    cancelData['reservationLocator'] = item?.resultReserve?.providerReservationId;
    cancelData['productsId'] = productsIdArr;
    break;
  case 2:
    cancelData['providerId'] = item?.providerId;
    cancelData['reservationLocator'] = item?.resultReserve?.additionalInfo?.idReservation;
    cancelData['productsId'] = productsIdArr;
    break;
  case 6:
    cancelData['providerId'] = item?.providerId;
    cancelData['reservationLocator'] = item?.resultReserve?.additionalInfo?.idReservation;
    cancelData['productsId'] = productsIdArr;
    break;
  case 8:
    cancelData['providerId'] = item?.providerId;
    cancelData['reservationLocator'] = item?.resultReserve?.providerReservationId;
    cancelData['productsId'] = productsIdArr;
    break;

}

    const itemCancelled = this.userService.itineraryActive[0].items.find(c => c.id === item.id);

    itemCancelled.amount_convert_cancellation= this.getCancellationPolicies(itemCancelled.category_id, item);
    this.userService.itineraryActive[0].clientId = this.itineraryService.itinerary.client_id;

    this._restService.doPut('app', `products/cancelReservation/${item?.itinerary_id}`, cancelData).subscribe({
      next: (res: any) => {
        this.ngxSpinner.hide();
        this.cancel.emit(item.id);
        this.notificationService.success('Su producto fue cancelado con éxito');
      this.itineraryService.updateItinerary(this.userService.itineraryActive[0], false);
    },
    error: (error: HttpErrorResponse) => {
      this.ngxSpinner.hide();
      this.notificationService.error('Ocurrio un error');
      console.log(error);
    }
  });
    // this.itineraryService.cancelReservation(item);

    // setTimeout(() => {
    //   this.cancel.emit(item.id);
    //   this.userService.updateProductsPrices(item.itinerary_id);
    // }, 1000);


  }


getCancellationPolicies(category, item) {
    const currentDate = new Date();
    const defaultPolicy = {
        currency: this.currencyAgency?.code,
        from: currentDate,
        amount: 0,
        apply: false
    };

    // Determinar el array de políticas según la categoría
    let policies = [];
    if (category === 1) {
        policies = item.room?.cancellationPolicy || [];
    } else if (category === 8) {
        policies = item.cancellationPolicies || [];
    }

    // Si no hay políticas, retornar el default
    if (policies.length === 0) {
        return [defaultPolicy];
    }

    // Ordenar políticas por fecha 'from'
    const sortedPolicies = [...policies].sort((a, b) =>
        new Date(a.from).getTime() - new Date(b.from).getTime()
    );

    // Encontrar la política aplicable
    let applicableIndex = -1;
    for (let i = 0; i < sortedPolicies.length; i++) {
        if (new Date(sortedPolicies[i].from) <= currentDate) {
            applicableIndex = i;
        } else {
            break;
        }
    }

    // Preparar el resultado con el campo apply
    const result = sortedPolicies.map((policy, index) => {
      const baseRate = this.currencies.find(c => c.code === policy.currency)?.rate || 1;
      const targetRate = this.currencyAgency?.rate || 1;

        const isApplicable = index === applicableIndex;
        const amount = (policy.amount / baseRate) * targetRate;

        return {
            ...policy,
            currency: this.currencyAgency?.code,
            amount,
            apply: isApplicable
        };
    });

    // Si no hay ninguna aplicable y hay políticas, marcamos todas como no aplicables
    if (applicableIndex === -1 && result.length > 0) {
      const targetRate2 = this.currencyAgency?.rate || 1;
      return result.map(policy => ({
            ...policy,
            currency: this.currencyAgency?.code,
            amount: (policy.amount / this.currencies.find(c => c.code === policy.currency)?.rate) * targetRate2,
            apply: false
        }));
    }

    return result;
}

  toPartialReserve(event, item: any){
    if ( event.target.checked ) {
      this.itineraryService.updateItineraryPartial(item);
      this.itemToPartial.emit(1);
    } else {
      this.itineraryService.updateItineraryPartial(item,true);
      this.itemToPartial.emit(-1);
    }
  }

  subtractDays(date){
    return moment(moment(date)).subtract(2, 'days').format('YYYY-MM-DD');
  }

  updateNRProduct(){

    const date = this.dato.expirationDate ? moment(new Date()) : null;

    if(date){
      if( (date > moment(this.dato.expirationDate).subtract(2, 'days')) ){



        this.userService.itineraryActive[0].items.forEach(element => {
          if(this.dato.id == element.id){
            element.nr = true;

            this.itineraryService.updateItinerary(this.userService.itineraryActive[0], false);
            return;
          }
        });

      }
    }


  }

  openModal() {

    const dialogRef = this.dialog.open(ModalsComponent, {
      height: '680px',
      width: '800px',
      data: {
        product: this.dato.product,
        productQty: '1',
        //form: this.activeItineraryForm,
        origin: 'HOTELS',
        itineraryItem:this.dato,
        view_info:true,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  // Pasar primer letra de cada palabra a mayuscula en una cadena
  // stingUpperCase(str){
  //   let e = str.toLowerCase()
  //   return e.replace(/\b\w/g, l => l.toUpperCase())
  // }

  fontPrice(price){
    if((price.length - 6) > 0){
      const fact = price.length - 6;
      const size = 25 - (1.5 * fact);
      return size + 'px';
    }
  }

  getStarsHotels(): void{
    const rateStar = this.dato.categoryHotel;
    if(rateStar != null){
      const numberRate = rateStar?.substring(0,1);
      this.rate = Number(numberRate);
    }
  }

  getDateArrivalApprove(dateArrival: any): boolean {
    return new Date(dateArrival) >= this.currentDate;
  }

  getRateClass(item: any): string {
    return item?.rateClassId ? item?.rateClassId : '';
  }

  getPrice(item): number {

      if(item.status_id == 5) {
        return 0;
      }

    let price: number;
    // Impuestos no incluidos (a pagar en destino) — solo para mostrar, no forma parte de
    // ningún total real del item. Vive en item.room.pricing, no en item directo.
    const taxesExcluded = item.room?.pricing?.taxesExcluded || 0;

      if(!item.isPendigApprovePay && !item.isPaidAgency && !item.isPaidProvider) {
        price = item.netPriceBooking > 0
          ? item.netPriceBooking
          : item.netPriceBookingFreeTax;
        price += taxesExcluded;

        price = this.currencyPipe.transform(
                                              price,
                                              item?.currency,
                                              this.currencyAgency?.code,
                                              this.currencies
                                            );
      }

      if(item.isPendigApprovePay || item.isPaidAgency || item.isPaidProvider) {
        if(item.converted_amounts) {
          price = item.converted_amounts.netPriceAgent + taxesExcluded;
        } else {
          price = item.optionNightsNetTotalProf > 0
                    ? item.optionNightsNetTotalProf
                    : item.optionNightNetTotalFreeTax;
          price += taxesExcluded;
        }


      }

      return price;

    }

    getImagenCover(data: any): string {
      if(data.hotelAdditionalInfo[0].images &&
        data.hotelAdditionalInfo[0].images.length > 0 &&
        data.hotelAdditionalInfo[0].images.some(c => c.is_cover === 1)) {
        return data.hotelAdditionalInfo[0].images.find(c => c.is_cover === 1).thumbnail;
      } else {
        return 'assets/img/app/hotel_default.png';
      }

    }

  /**
   * Devuelve todas las habitaciones a mostrar (dato + rooms adicionales).
   * Si no hay rooms, devuelve solo [dato] (comportamiento original).
   * CACHEADO: usar la propiedad displayRooms en el template.
   */
  getDisplayRooms(): any[] {
    return this.displayRooms;
  }

  /**
   * Precio total sumando todas las habitaciones del mismo hotel.
   * CACHEADO: usar la propiedad totalPrice en el template.
   */
  getTotalPrice(): number {
    return this.totalPrice;
  }

  /**
   * Cantidad total de habitaciones.
   * CACHEADO: usar la propiedad roomCount en el template.
   */
  getRoomCount(): number {
    return this.roomCount;
  }

  /**
   * Determina si el hotel incluye desayuno basado en boardName.
   * boardName puede ser: "BED AND BREAKFAST", "HALF BOARD", "FULL BOARD", "ROOM ONLY", etc.
   */
  hasBreakfast(): boolean {
    const boardName = (this.dato?.boardName || this.dato?.room?.boardName || '').toUpperCase();
    return boardName.includes('BREAKFAST') || boardName.includes('HALF BOARD') || boardName.includes('FULL BOARD');
  }


}

